import React, { useEffect, useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Media
} from 'reactstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// constants
import LocalStrings from '../../assets/languages';
import {
  CDN_URL,
  INTERVAL_10,
  PUBLIC_WITH_TICKET_URL,
  PUBLIC_WITH_REG_URL
} from '../../constants/constant';
import appIcons from '../../constants/appIcons';
import {
  getConditionalCommonFeatures,
  getSameDomainBaseUrl,
  getTextWithTruncate,
  getThumbImageUrl,
  getUserRolePrivilege,
  replaceAll,
  useInterval
} from '../../util/util-common';
import { ALLOWED_FEATURE_KEYS } from '../../constants/section-constants/common-constants';
import {
  RESTRICTED_REGISTRATION_BUTTON_EVENT_POLICIES,
  SITE_ACCESS_TYPES
} from '../../constants/section-constants/type-constants';

// actions
import {
  showSidebar,
  loginModal,
  fetchEventForms,
  fetchUnreadChat,
  setProfilePortalToggle,
  fetchReportedContentsByUser,
  fetchUserAddonData
} from '../../actions';
import { fetchUnreadNotificationCount } from '../notifications/actions';
import { setHSPopup } from '../Common/horizontal-sliding-popup/actions';
import {
  clearUserNotifications,
  clearSocialDetails,
  setSelectedNotification,
  fetchUserNotifications
} from '../notifications/actions';

// components
import UserProfilePic from '../Common/userProfilePic';
import LineLoader from '../Common/LinearLoader';
import AppSettings from './AppSettings';

// files
import NoImgIcon from '../../assets/img/placeholders/NoImg.svg';

const AdminNavbar = props => {
  const {
    isLoggedIn,
    session,
    eventDetails,
    eventSettings,
    userDetails,
    routes,
    deviceSize,
    notificationReducer,
    allowIterableCalls,
    handleEditProfileToggle,
    profileToggleReducer,
    siteControl,
    lineLoaderReducer,
    profileToggleItems,
    rolePermissions_scan,
    rolePermissions_message
  } = props;

  const location = useLocation();
  const history = useHistory();
  const [DDToggle, setDDToggle] = useState(false);
  const [settingsModalOpen, setSettingsModalOpen] = useState(false);

  useEffect(() => {
    withIntervalAPIs();
  }, []);

  useInterval(() => {
    withIntervalAPIs();
  }, INTERVAL_10);

  const eventPolicy = eventSettings?.eventpolicytype;
  const isLinked =
    userDetails?.exhibitoridfk ||
    userDetails?.speakeridfk ||
    userDetails?.sponsoridfk;

  let regUrl = ``;
  switch (eventPolicy) {
    case 'public_with_ticket':
      regUrl = replaceAll(
        PUBLIC_WITH_TICKET_URL,
        ['###BASE_URL###'],
        [getSameDomainBaseUrl(session)]
      );
      break;

    case 'public_with_reg':
      regUrl = replaceAll(
        PUBLIC_WITH_REG_URL,
        ['###BASE_URL###'],
        [getSameDomainBaseUrl(session)]
      );
      break;

    case 'external_registration_link':
      regUrl = eventSettings?.external_registration_url;
      break;

    default:
      regUrl = replaceAll(
        PUBLIC_WITH_REG_URL,
        ['###BASE_URL###'],
        [getSameDomainBaseUrl(session)]
      );
      break;
  }

  const withIntervalAPIs = () => {
    if (allowIterableCalls) {
      if (rolePermissions_message?.message) props.fetchUnreadChat(session);
      if (
        getConditionalCommonFeatures(eventSettings)?.[
          ALLOWED_FEATURE_KEYS.notifications
        ]
      )
        props.fetchUnreadNotificationCount(session, res => {});

      props.fetchReportedContentsByUser(session, res => {});
      props.fetchUserAddonData(session, userDetails);
    }

    if (!_.isEmpty(session?.sessionToken)) {
    }
  };

  const handleExternalRedirect = () => {
    window.open(regUrl, '_blank');
  };

  // ----- Event logo -----
  const eventLogo = !_.isEmpty(eventDetails?.eventicon)
    ? `${CDN_URL}${getThumbImageUrl(eventDetails?.eventicon)}`
    : '';
  // ----- Ends -----

  /* ------------------------ On-click functions start ------------------------ */
  const handleOpenSideBarForMobile = bool => {
    props.showSidebar(bool);
  };

  const handleAppLogin = () => {
    props.loginModal({ showModal: true });
  };

  const handleDDSelect = () => {
    setDDToggle(!DDToggle);
    props.setHSPopup('clear');
    handleEditProfileToggle();
  };

  const handleNotificationClick = () => {
    props.clearSocialDetails();
    props.setSelectedNotification({});

    if (location.pathname == '/notifications') {
      props.clearUserNotifications();
      props.fetchUserNotifications(session, res => {});
    } else handleEditProfileToggle();
  };

  const handleProfileModeSelects = type => {
    if (!profileToggleReducer?.show) handleEditProfileToggle('profile');
    else {
      history.push({
        pathname: `/myprofile${type === 'profile' ? '' : `-${type}`}`
      });

      let selectedTab = _.find(profileToggleReducer.data[type]);
      let local_profileToggleReducer = _.cloneDeep(profileToggleReducer);
      local_profileToggleReducer.type = type;
      local_profileToggleReducer.active_tab = selectedTab;
      local_profileToggleReducer.sections = [];
      _.map(profileToggleReducer.data[type], (section, sectionIndex) =>
        local_profileToggleReducer.sections.push(sectionIndex)
      );
      local_profileToggleReducer.activeIndex = 0;

      props.setProfilePortalToggle(local_profileToggleReducer);
    }
  };
  /* ------------------------- On-click functions end ------------------------- */

  /* ------------------------- Render functions starts ------------------------ */
  const _renderProfileDDItems = () => {
    const routesNew = _.filter(routes, list => {
      if (deviceSize.width < 991) {
        return (
          list.display && list.position === 'top' && list.section === 'menu'
        );
      } else {
        return list.display && list.position === 'top';
      }
    }); // custom check is login not display in sidebar

    return (
      <>
        {_.map(routesNew, (prop, key) => {
          if (
            !prop.hasAccess ||
            (_.isEqual(ALLOWED_FEATURE_KEYS.scans, prop.key) &&
              !rolePermissions_scan?.allow_scan &&
              rolePermissions_scan?.show_retrieve)
            // || (!_.isEmpty(userDetails) &&
            // !_.isEqual(userDetails?.comesfrom, 'ticket') &&
            // _.isEqual(prop.path, '/mytickets'))
          )
            return;

          const selected = _.includes(location.pathname, prop.path);
          const menuClass = `menu-link mb-1 ${
            selected ? 'selected-menu' : 'unselected-menu'
          }`;
          const menuName =
            !_.isNil(userDetails?.exhibitoridfk) &&
            _.isEqual(ALLOWED_FEATURE_KEYS.scans, prop.key)
              ? LocalStrings.dynamic.KMyLeads
              : LocalStrings.dynamic[prop.languageKey];

          return (
            <DropdownItem
              key={`key_${key}`}
              to={`${prop.path}`}
              className={menuClass}
              tag={Link}
              onClick={handleDDSelect}
            >
              <div className="menu-icons">{prop.icon}</div>{' '}
              <div className="menu-name">{menuName}</div>
            </DropdownItem>
          );
        })}
      </>
    );
  };

  const _renderEventSettingsDD = () => {
    return (
      <div className={`login-logout-section ${isLoggedIn ? 'login' : ''}`}>
        <div
          className=""
          id={!deviceSize.isMobile ? 'navbar-main' : 'navbar-main-mobile'}
        >
          <Nav className="align-items-center d-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="font-icomoon custom-text4-medium-primary cursor-pointer">
                    {appIcons.threeDotVerticalIcon}
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                {isLoggedIn &&
                deviceSize.isMobile &&
                !_.isEqual(SITE_ACCESS_TYPES.restrict, siteControl) &&
                !profileToggleReducer?.show
                  ? _renderProfileDDItems()
                  : ''}

                {/* --- Settings button --- */}
                <DropdownItem
                  className="menu-link mb-1 unselected-menu"
                  onClick={() => setSettingsModalOpen(true)}
                >
                  <div className="menu-icons">{appIcons.gearIcon}</div>{' '}
                  <div className="menu-name">
                    {LocalStrings.dynamic.kSettings}
                  </div>
                </DropdownItem>

                {/* --- Logout button --- */}
                {isLoggedIn && (
                  <DropdownItem
                    className="menu-link mb-1 unselected-menu"
                    onClick={props.handleAppLogout}
                  >
                    <div className="menu-icons">{appIcons.logoutIcon}</div>{' '}
                    <div className="menu-name">
                      {LocalStrings.dynamic.kLogoutText}
                    </div>
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </div>
      </div>
    );
  };

  const _renderNotification = (isLeft = false) => {
    if (
      !getConditionalCommonFeatures(eventSettings)?.[
        ALLOWED_FEATURE_KEYS.notifications
      ]
    )
      return <></>;

    return (
      <a
        className="position-relative"
        href={`#/notifications`}
        onClick={handleNotificationClick}
      >
        <div
          className={`${
            isLeft ? 'notification-icon-left mr-2' : 'notification-icon-right'
          }`}
        >
          {appIcons.bellIcon}
        </div>
        {notificationReducer?.unread > 0 ? (
          <div
            className={`${
              isLeft
                ? 'notification-left-unread-count'
                : 'notification-right-unread-count'
            }`}
            style={notificationReducer?.unread > 99 ? { width: 22 } : {}}
          >
            {notificationReducer?.unread > 99
              ? '99+'
              : notificationReducer?.unread}
          </div>
        ) : (
          ''
        )}
      </a>
    );
  };
  /* -------------------------- Render functions ends ------------------------- */

  return (
    <div
      className="header-container"
      style={{
        ...(profileToggleReducer?.show
          ? deviceSize.isMobile && isLinked
            ? // ? { height: '11.126rem' }
              { height: '8.126rem' }
            : { padding: '0.5rem' }
          : !deviceSize.isMobile
          ? { padding: '0.5rem 0' }
          : {})
      }}
    >
      {/* --------- Navbar section - w/ Profile toggle for Web View --------- */}
      <div
        className={`row header mx-0`}
        // style={deviceSize.isMobile ? { padding: 0 } : {}}
      >
        {/* ------- Hamburger logo for mobile - Event logo - Event title - Event duration - Profile portal buttons ------- */}
        <div
          className={`col-${deviceSize.isMobile ? '10 pl-2' : '9'} pr-0 ${
            !profileToggleReducer?.show
              ? 'hamburger-logo-title-section'
              : 'hamburger-logo-title-section-with-profile-toggler'
          }`}
        >
          {/* ----- Hamburger logo for mobile - Event logo - Event title - Event duration ----- */}
          <div className="d-flex justify-content-center align-items-center">
            {/* ------ hamburger logo for mobile screen ------ */}
            {isLoggedIn && (
              <div className="d-block d-sm-block d-md-block d-lg-none hamburger-section">
                <span
                  className="font-icomoon custom-text4-medium-primary"
                  onClick={e => handleOpenSideBarForMobile(true)}
                >
                  {appIcons.menuHamburgerIcon}
                </span>
              </div>
            )}

            {/* ----- event logo ----- */}
            <div className=" d-flex justify-content-center align-items-center position-relative logo-section">
              <div style={{ zIndex: 2 }}>
                <LazyLoadImage
                  alt={'Image'}
                  effect="blur"
                  placeholder={
                    <img
                      src={NoImgIcon}
                      className="logo"
                      alt="lazy load placeholder on error"
                    />
                  }
                  className="logo"
                  src={eventLogo}
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = NoImgIcon;
                  }}
                />
              </div>
              <div
                className="position-absolute"
                style={{
                  zIndex: 1,
                  color: 'var(--theme-color)'
                }}
              >
                <i className={`fa fa-refresh fa-spin`}></i>
              </div>
            </div>

            {/* ----- Event details - Site open timer ----- */}
            <div className="d-flex flex-column">
              {/* --- event title --- */}
              <div className="title-section">
                {deviceSize.width >= 500 && (
                  <div className="title1">
                    {deviceSize.isMobile
                      ? getTextWithTruncate(eventDetails?.eventname, 30)
                      : eventDetails?.eventname}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ----- Profile portal buttons ----- */}
          {!_.isEmpty(session?.sessionToken) &&
          profileToggleItems.length &&
          profileToggleReducer.show &&
          !deviceSize.isMobile ? (
            <div className="profile-toggle-buttons custom-text1-normal">
              {/* --- Profile --- */}
              <button
                className={`${
                  profileToggleReducer?.type === 'profile' ? 'selected' : ''
                }`}
                onClick={() => handleProfileModeSelects('profile')}
              >
                <span>{`${LocalStrings.dynamic.kPersonal} ${LocalStrings.dynamic.kMode}`}</span>
              </button>

              {_.map(profileToggleItems, (tab, tabIndex) => {
                return (
                  <button
                    key={tabIndex}
                    className={`${
                      profileToggleReducer?.type === tab.tabslected
                        ? 'selected'
                        : ''
                    }`}
                    onClick={() => handleProfileModeSelects(tab.tabslected)}
                  >
                    <span>
                      {tab.displaytabname} {LocalStrings.dynamic.kMode}
                    </span>
                  </button>
                );
              })}
            </div>
          ) : (
            ''
          )}
        </div>

        {/* ------- Attendee profile - Dropdown - Notification - Three dots - Login button ------- */}
        <div
          className={`col-${
            deviceSize.isMobile ? '2 pr-2' : '3'
          } px-0 profile-notification-dropdown-section`}
        >
          {/* ----- after login - profile img - name - arrow for web view ----- */}
          {isLoggedIn ? (
            <div className="fixed-menu-section d-none d-lg-block">
              <Navbar
                className="navbar-top navbar-dark"
                expand="md"
                id="navbar-main"
              >
                <Nav className="align-items-center d-none d-md-flex" navbar>
                  <UncontrolledDropdown nav>
                    <DropdownToggle
                      className={`pr-0`}
                      nav
                      onClick={() =>
                        siteControl !== SITE_ACCESS_TYPES.restrict
                          ? setDDToggle(!DDToggle)
                          : null
                      }
                    >
                      <Media className="align-items-center">
                        {/* ------ profile img ------ */}
                        <div className="avatar">
                          <UserProfilePic
                            size={40}
                            info={userDetails}
                            disable
                            openProfile={false}
                            dontCheckNW
                          />
                        </div>

                        {/* ---- user name ---- */}
                        <Media
                          className="d-md-none d-lg-block avatar-name"
                          style={{
                            margin: '0.25rem 0.5rem 0'
                          }}
                        >
                          <span className="custom-text1-medium">
                            {profileToggleReducer?.show
                              ? userDetails?.firstname
                              : userDetails?.username}
                          </span>
                        </Media>

                        {/* ----- arrow ---- */}
                        {siteControl !== SITE_ACCESS_TYPES.restrict && (
                          <Media>
                            <span>
                              {DDToggle ? (
                                <i
                                  className="arrow up"
                                  style={{
                                    marginTop: 4
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="arrow down"
                                  style={{
                                    marginBottom: 1
                                  }}
                                ></i>
                              )}
                            </span>
                          </Media>
                        )}
                      </Media>
                    </DropdownToggle>

                    {siteControl !== SITE_ACCESS_TYPES.restrict && (
                      <DropdownMenu className="dropdown-menu-arrow" right>
                        {/* ----- Edit profile | Sub-profile portal gateway | Button ----- */}
                        {!profileToggleReducer?.show && (
                          <DropdownItem
                            className="menu-link mb-1 unselected-menu"
                            onClick={() => handleEditProfileToggle('profile')}
                          >
                            <div className="menu-icons">
                              {appIcons.profileIcon}
                            </div>{' '}
                            <div className="menu-name">
                              {LocalStrings.dynamic.kEditProfile}
                            </div>
                          </DropdownItem>
                        )}

                        {/* ----- Route menus for profile dropdown section ----- */}
                        {_renderProfileDDItems()}
                      </DropdownMenu>
                    )}
                  </UncontrolledDropdown>
                </Nav>

                {/* ------- Web | Notification icon and count - Global search -------- */}
                <div
                  className="notification-search-section"
                  style={
                    siteControl === SITE_ACCESS_TYPES.restrict
                      ? { display: 'none' }
                      : {}
                  }
                >
                  {/* --- Notification --- */}
                  {_renderNotification(false)}

                  {/* --- Global search --- */}
                  <a
                    className=""
                    // to={`globalsearch`}
                    href={`#/globalsearch`}
                  >
                    <div
                      className={`${
                        // isLoggedIn ? 'custom-icons' : 'custom-icons-primary'
                        'custom-icons-primary'
                      } notification-icon-right m-0`}
                      onClick={handleEditProfileToggle}
                    >
                      {appIcons.searchIcon}
                    </div>
                  </a>
                </div>
              </Navbar>
            </div>
          ) : (
            ''
          )}

          {/* ----- Mobile view | Notification button & count - Global search ----- */}
          {siteControl !== SITE_ACCESS_TYPES.restrict &&
          isLoggedIn &&
          (deviceSize.isMobile || deviceSize.width < 991) ? (
            <>
              <div className="d-flex" style={{ gap: '0.5rem' }}>
                {profileToggleReducer?.show ? (
                  <>
                    {/* --- Profile mode leave --- */}
                    <div
                      className="custom-text9-medium-theme"
                      onClick={handleEditProfileToggle}
                      style={{ minWidth: 77 }}
                    >
                      {`${_.startCase(LocalStrings.dynamic.KToText)} ${
                        LocalStrings.dynamic.kOverviewText
                      }`}
                    </div>
                  </>
                ) : (
                  <>
                    {/* --- Notification --- */}
                    {_renderNotification(true)}

                    {/* --- Global search --- */}
                    <a
                      className=""
                      // to={`globalsearch`}
                      href={`#/globalsearch`}
                    >
                      <div
                        className={`${'custom-icons-primary'} notification-icon-right`}
                        onClick={handleEditProfileToggle}
                      >
                        {appIcons.searchIcon}
                      </div>
                    </a>
                  </>
                )}
              </div>
            </>
          ) : (
            ''
          )}

          {/* ----- Mobile view | Login logout three dots ----- */}
          <div
            className={`login-logout-section ${
              // isLoggedIn ? 'login d-block d-lg-none' : `d-flex`
              isLoggedIn ? 'd-none' : `d-flex`
            }`}
          >
            {isLoggedIn ? (
              siteControl !== SITE_ACCESS_TYPES.restrict ? (
                <>
                  <div
                    className=""
                    id={
                      !deviceSize.isMobile
                        ? 'navbar-main'
                        : 'navbar-main-mobile'
                    }
                  >
                    {!profileToggleReducer?.show ? (
                      <Nav className="align-items-center d-flex" navbar>
                        <UncontrolledDropdown nav>
                          <DropdownToggle className="pr-0" nav>
                            <Media className="align-items-center">
                              <span className="font-icomoon custom-text2-medium-primary">
                                {appIcons.threeDotVerticalIcon}
                              </span>
                            </Media>
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-arrow" right>
                            {_renderProfileDDItems()}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </Nav>
                    ) : (
                      ''
                    )}
                  </div>
                </>
              ) : (
                ''
              )
            ) : (
              <>
                {!_.includes(
                  RESTRICTED_REGISTRATION_BUTTON_EVENT_POLICIES,
                  eventPolicy
                ) ? (
                  <button
                    type="button"
                    onClick={handleExternalRedirect}
                    className={`login-button text-nowrap ${
                      deviceSize.isMobile ? 'd-none' : ''
                    }`}
                    style={{
                      borderRadius: '0.5rem'
                    }}
                  >
                    {LocalStrings.dynamic.KRegisterNow}
                  </button>
                ) : (
                  ''
                )}

                <button
                  type="button"
                  onClick={handleAppLogin}
                  className="login-text ml-2 text-nowrap border-0 bg-white"
                >
                  {LocalStrings.dynamic.kLoginText}
                </button>
              </>
            )}
          </div>

          {/* ----- Event settings related DD ----- */}
          {_renderEventSettingsDD()}
        </div>
      </div>

      {/* --------- Profile Toggle for Mobile view --------- */}
      {!_.isEmpty(session?.sessionToken) &&
      deviceSize.isMobile &&
      profileToggleReducer?.show &&
      profileToggleItems?.length ? (
        <div className="row mx-0 header mobile">
          <div className="w-100">
            <label className="d-flex justify-content-between w-100">
              <div className="custom-text9-medium-primary">
                {LocalStrings.dynamic.kMode}
              </div>
            </label>
          </div>

          <div className="profile-toggle-buttons custom-text9-normal-primary">
            {/* --- Profile --- */}
            <button
              className={`${
                profileToggleReducer?.type === 'profile' ? 'selected' : ''
              }`}
              onClick={() => handleProfileModeSelects('profile')}
            >
              <span>{LocalStrings.dynamic.kProfileText}</span>
            </button>

            {_.map(profileToggleItems, (tab, tabIndex) => {
              return (
                <button
                  key={tabIndex}
                  className={`${
                    profileToggleReducer?.type === tab.tabslected
                      ? 'selected'
                      : ''
                  }`}
                  onClick={() => handleProfileModeSelects(tab.tabslected)}
                >
                  <span>{tab.displaytabname}</span>
                </button>
              );
            })}
          </div>
        </div>
      ) : (
        ''
      )}

      {/* --------- Common Line loader animation --------- */}
      {lineLoaderReducer && (
        <div className="line-loader-container">
          <LineLoader />
        </div>
      )}

      {/* --------- Event settings modal --------- */}
      {settingsModalOpen && (
        <AppSettings
          isOpen={settingsModalOpen}
          closeModal={() => setSettingsModalOpen(false)}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => {
  let allowIterableCalls = false;
  if (
    state.isLoggedIn &&
    !_.isEmpty(state.session?.sessionToken) &&
    !state.stopApiCalls
  ) {
    allowIterableCalls = true;
  }

  const rolePermissions_scan = getUserRolePrivilege(
    state.userDetails,
    state.eventTabs,
    state.userAccessByRole,
    ALLOWED_FEATURE_KEYS.scans
  );

  const rolePermissions_message = getUserRolePrivilege(
    state.userDetails,
    state.eventTabs,
    state.userAccessByRole,
    ALLOWED_FEATURE_KEYS.message
  );

  // --- Overview page items | Schedule, Speaker, Exhibitor, Sponsor, Maps
  let profileToggleItems = [];
  let requiredSectionsToCheck = ['exhibitor', 'speaker', 'sponsor'];
  !_.isEmpty(state.userDetails) &&
    !_.isEmpty(state.eventTabs) &&
    _.map(state.eventTabs, (tab, tabIndex) => {
      if (
        _.includes(requiredSectionsToCheck, tab?.tabslected) &&
        tab?.isenabled
      ) {
        let pushItem = false;

        switch (tab.tabslected) {
          case 'exhibitor':
            if (state.userDetails?.exhibitoridfk) pushItem = true;
            break;

          case 'sponsor':
            if (state.userDetails?.sponsoridfk) pushItem = true;
            break;

          case 'speaker':
            if (state.userDetails?.speakeridfk) pushItem = true;
            break;

          default:
            break;
        }
        pushItem && profileToggleItems.push(tab);
      } else {
      }
    });
  _.orderBy(profileToggleItems, 'taborder', 'asc');

  return {
    isLoggedIn: state.isLoggedIn,
    session: state.session,
    modalStatus: state.loginModalReducer,
    show: state.showSidebar,
    eventDetails: state.eventDetails,
    eventSettings: state.eventSettings,
    userDetails: state.userDetails,
    deviceSize: state.deviceSize,
    networkingReducer: state.networkingReducer,
    notificationReducer: state.notificationUnreadCountReducer,
    profileToggleReducer: state.profileToggleReducer,
    siteControl: state.siteControlReducer,
    lineLoaderReducer: state.lineLoaderReducer,
    profileToggleItems,
    allowIterableCalls,
    rolePermissions_scan,
    rolePermissions_message
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showSidebar,
      loginModal,
      fetchUnreadChat,
      setHSPopup,
      fetchUnreadNotificationCount,
      clearSocialDetails,
      setSelectedNotification,
      fetchEventForms,
      fetchUserNotifications,
      clearUserNotifications,
      setProfilePortalToggle,
      fetchReportedContentsByUser,
      fetchUserAddonData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar);
